import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-xl font-heading tracking-wide bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">
                飞飞漫画
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              飞飞漫画网提供海量免费漫画在线看，涵盖国漫、日漫、韩漫等类型。下拉式阅读，流畅追更，让漫画爱好者畅享阅读乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">
              <a href="#footer-categories" className="cursor-pointer">漫画分类</a>
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">
              <a href="#footer-more-categories" className="cursor-pointer">更多分类</a>
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(6).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">
              <a href="#footer-links" className="cursor-pointer">快速链接</a>
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              <Link to="/category/guoman" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">国漫专区</Link>
              <Link to="/category/riman" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">日漫专区</Link>
              <Link to="/category/hanman" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">韩漫专区</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 飞飞漫画网 — 免费漫画在线看，下拉式阅读新体验
          </p>
          <div className="flex items-center gap-4">
            <a href="#privacy" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#terms" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
            <a href="#contact" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}